<template>
  <div class="bottom_more_information">
    <div class="more_information">
      <div class="more_information_content">
        <div class="left_connect_information">
          <div class="connect_mobile connect_item">
            <div class="connect_icon mobile_icon">
              <img src="../assets/images/bottom_nav_phone.png"
                   alt>
            </div>
            <div class="connect_item_infor">{{contactInfo.phone}}</div>
          </div>
          <div class="connect_email connect_item">
            <div class="connect_icon email_icon">
              <img src="../assets/images/nav_bottom_email.png"
                   alt>
            </div>
            <div class="connect_item_infor">{{contactInfo.email}}</div>
          </div>
          <div class="connect_qrcode connect_item">
            <div class="connect_icon qrcode_icon">
              <img src="../assets/images/nav_bottom_weixin.png"
                   alt>
            </div>
            <div class="connect_item_qrcode">
              <div class="qrcode1 qrcode base_banner"
                   :style="{'background-image':'url('+comPath+contactInfo.qrcode+')'}"></div>
              <div class="qrcode2 qrcode"></div>
            </div>
          </div>
        </div>
        <div class="bottom_right_nav_info">
          <div class="bottom_nav_item"
               @click="toHref(item.link,item.id)"
               v-for="(item,index) in bottomNavList"
               :key="index">{{item.menu_title}}</div>
        </div>
      </div>
      <div class="bottom_copyright_info"><a href="https://beian.miit.gov.cn/">沪ICP证15034641号-1 </a>Copyright © 2015 - 2019 悦米版权所有
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bottomNavList: [],
      contactInfo: {
        email: "",
        logimg: "",
        phone: "",
        qrcode: ""
      },
    };
  },
  created () { },
  mounted () {
    this.getBottomNavList();
    this.getCcontactInfo()
  },
  methods: {
    toHref (href, id) {
      //location.href = `${href}?id=${id}`;
      if (href === '/') {
        // this.$router.push({path: href})
        window.location.href = location.origin
      } else {
        this.$router.push({ path: href, query: { id: id } })
      }
      this.activeId = id
      this.$emit("close");
    },
    getCcontactInfo () {
      let url = "/api/home/gainglobalstyle";
      this.$http.get(url).then(res => {
        // console.log("底部信息", res);
        if (res.data.ret === 0) {
          this.contactInfo.email = res.data.lister[0].email;
          this.contactInfo.logimg = res.data.lister[0].logimg;
          this.contactInfo.phone = res.data.lister[0].phone;
          this.contactInfo.qrcode = res.data.lister[0].qrcode;
        }
        // console.log(this.contactInfo);
      });
    },
    //  底部导航
    getBottomNavList () {
      let url = "/api/home/gainmenu";
      let params = {
        type_id: 1
      };
      this.$http.get(url, { params }).then(res => {
        if (res.data.ret === 0) {
          res.data.lister.splice(3, 0, {
            describe: "关于悦米-悦米",
            id: 6,
            link: "/state",
            menu_title: "隐私保护",
            seokey: "生命科学,药企营销,科室会,远程直播,医药营销,主数据管理,微信公众号运营,公众号开发",
            wxlink: "/state"
          })
          this.bottomNavList = res.data.lister;
          // console.log("底部导航", res);
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '../assets/css/baseFontAndColor.styl'
.bottom_more_information
  width 100%
  height 500px
  /* border-top: 0.1px solid rgba(17, 141, 182, 1) */
  background linear-gradient(180deg, rgba(45, 45, 45, 1) 0%, rgba(38, 38, 38, 1) 100%)
  .more_information
    margin 0 auto
    padding-top 55px
    width 1200px
    .more_information_content
      display flex
      justify-content space-between
      padding-bottom 73px
      border-bottom 1px solid rgba(255, 255, 255, 0.3)
      .left_connect_information
        // width 500px
        .connect_item
          display flex
          justify-content flex-start
          .connect_icon
            width 58px
            height 58px
            img
              width 58px
              height 58px
              border-radius 50%
          .connect_item_infor
            flex 1
            margin-left 22px
            color #ffffff
            font-weight lighter
            font-weight 300
            font-size 30px
        .connect_mobile,
        .connect_email
          align-items center
          margin-bottom 26px
        .connect_qrcode
          margin-top 29px
          width 100%
          height 120px
          .qrcode_icon
            width 58px !important
            height 58px
          .connect_item_qrcode
            display flex
            justify-content flex-start
            margin-left 22px
            // width 400px
            .qrcode
              margin-right 34px
              width 120px
              height 120px
    .bottom_right_nav_info
      padding-top 5px
      .bottom_nav_item
        margin-bottom 20px
        color #fff
        text-align center
        font-size 16px
        line-height 22px
        cursor pointer
    .bottom_copyright_info
      height 78px
      color #fff
      text-align center
      font-size 14px
      line-height 78px
      a
        display inline-block
        margin-right 6px
        color #fff
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue